import { render, staticRenderFns } from "./NewSubjectSpecialties.vue?vue&type=template&id=dff217b0&"
import script from "./NewSubjectSpecialties.vue?vue&type=script&lang=js&"
export * from "./NewSubjectSpecialties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports